import './index.scss'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

const NotFoundPage = observer(() => {
    return (
        <div className="not-found-page">
            <div className="container">
                <div className="error-code">
                    404
                </div>
                <div className="description">
                    Səhifə tapılmadı
                </div>
                <div className="to-main">
                    <Link to="/">
                        <button type="button" className="button">
                            Ana səhifəyə qayıt
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
})

export { NotFoundPage }